import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Mail, MapPin } from "lucide-react";

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border/50 bg-background/80 backdrop-blur-sm mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-2 space-y-4">
            <div className="flex items-center gap-2">
              <span className="text-2xl">🎂</span>
              <span className="font-bold font-['Sora'] text-lg">SkyBday</span>
            </div>
            <p className="text-sm text-muted-foreground max-w-md">
              {t('landing.hero.subtitle')}
            </p>
            {/* App Store Badge */}
            <a 
              href="https://apps.apple.com/ch/app/skybday-pro/id6757096143?l=fr-FR"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block hover:opacity-80 transition-opacity"
              aria-label={t('footer.downloadApp')}
            >
              <img 
                src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/fr-fr?size=250x83&amp;releaseDate=1704067200"
                alt={t('footer.downloadApp')}
                className="h-10"
                loading="lazy"
              />
            </a>
          </div>

          {/* Liens légaux */}
          <div className="space-y-4">
            <h3 className="font-semibold text-sm uppercase tracking-wider text-muted-foreground">
              {t('footer.legalInfo')}
            </h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/legal" 
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  {t('footer.legalNotice')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/privacy" 
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  {t('settings.privacyPolicy')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms" 
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  {t('settings.termsOfService')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="font-semibold text-sm uppercase tracking-wider text-muted-foreground">
              {t('settings.contactUs')}
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-muted-foreground">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span>
                  Elevatis SA<br />
                  Rue du Gruyet 3<br />
                  2065 Savagnier, Suisse
                </span>
              </li>
              <li>
                <a 
                  href="mailto:gestion@elevatis.ch"
                  className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  gestion@elevatis.ch
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 pt-6 border-t border-border/50 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {currentYear} SkyBday - Elevatis SA. {t('footer.allRightsReserved')}
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-muted-foreground flex items-center gap-1">
              🇨🇭 Made in Switzerland
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
